export default __webpack_public_path__ + "static/media/image-zx7.37f08eea.jpg";